import React from 'react';
import _ from 'lodash';
import styled from 'styled-components';

import useTranslation from 'hooks/use-translation';
import { Tooltip, Button } from 'shared/components';

export default function Reward({
  combineDiscounts,
  hasAppliedAnyRewards,
  hasDiscount,
  hasCoupon,
  isRewardApplied,
  onApplyReward,
  onUndoReward,
  reward,
  rewardsType,
  hideApplyButton = false,
}) {
  const { t } = useTranslation();
  const isDisabled = (hasAppliedAnyRewards && !isRewardApplied) || (!combineDiscounts && (hasDiscount || hasCoupon));
  const tooltipCopy =
    hasDiscount && !combineDiscounts
      ? `${
          !rewardsType ? `Rewards` : `${rewardsType} rewards`
        } can't be applied when your order contains a sale item, promo code, or other discount.`
      : `Only one reward can be applied per order.`;

  // if a reward was previously applied, but we still have a discounted item
  // undo our reward so that these don't double up unless we allow combined discounts
  if (isRewardApplied && !combineDiscounts && (hasDiscount || hasCoupon)) {
    onUndoReward(reward.id);
  }

  return (
    <RewardContainer key={reward.copy}>
      <RewardCopy disabled={isDisabled}>
        <b>{reward.copy}</b>
        {reward.costV2 ? ` (${reward.costV2} pts)` : ''}
      </RewardCopy>
      {!hideApplyButton && (
        <ButtonContainer>
          {(!hasAppliedAnyRewards || isDisabled) && (
            <Tooltip
              hoverMain
              allowHoverAction={isDisabled}
              mainCopy={
                // eslint-disable-next-line react/jsx-wrap-multilines
                <Button
                  loading={false}
                  gray
                  onClick={() => (isDisabled ? _.noop : onApplyReward(reward.id))}
                  height='27px'
                  width='64px'
                  fontSize='12px'
                  p='0'
                >
                  {t('rewardsWallet.apply', 'Apply')}
                </Button>
              }
              tooltipCopy={tooltipCopy}
              bottom='40px'
              right='-36px'
              icon={{ src: `/icons/info-icon.svg` }}
            />
          )}
          {hasAppliedAnyRewards && isRewardApplied && !isDisabled && (
            <>
              <CheckImage alt='Checkmark Icon' src='/icons/green-checkmark.svg' />
              <Applied>{t('rewardsWallet.appliedExclamation', 'Applied!')}</Applied>
              {/* eslint-disable-next-line styled-components-a11y/click-events-have-key-events, styled-components-a11y/no-static-element-interactions */}
              <UndoButton onClick={() => onUndoReward(reward.id)}>{t('rewardsWallet.apply', 'Undo')}</UndoButton>
            </>
          )}
        </ButtonContainer>
      )}
    </RewardContainer>
  );
}

const RewardContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  margin-top: 18px;
`;

const RewardCopy = styled.p`
  font-size: 14px;
  color: ${(props) => (props.disabled ? `#c0c8d1` : `#5d666d`)};
  b {
    font-weight: bold;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 27px;
`;

const CheckImage = styled.img`
  width: 11px;
  height: 9px;
  margin-right: 4px;
`;

const Applied = styled.p`
  font-size: 13px;
  font-weight: bold;
  color: #4ca667;
  margin-right: 5px;
`;

const UndoButton = styled.div`
  font-size: 12px;
  line-height: 13px;
  color: var(--dct--customized-colors-buttonsLinks, ${({ theme }) => theme.customized.colors.buttonsLinks});
  cursor: pointer;
`;
